export default __webpack_public_path__ + "static/media/fast-funding.ee1d565e.svg";